export default "__VITE_ASSET__BWTSjR07__"